import { render } from "./TeoAdminConnect.vue?vue&type=template&id=c05cdaee"
import script from "./TeoAdminConnect.vue?vue&type=script&lang=js"
export * from "./TeoAdminConnect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__